import React from 'react';
import { PropTypes } from 'prop-types';
import clsx from 'clsx';
import { isPresent } from 'utils/helperMethods';
import { Dialog, IconButton, Typography, Button } from '@material-ui/core';
import LoanOfficerInfoBar from 'sharedComponents/LoanOfficerInfoBar';
import VideoPlayer from 'sharedComponents/VideoPlayer';

import { useTranslation } from 'react-i18next';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';

import Icon from 'sharedComponents/Icon';
import useScreen from 'hooks/useScreen';

import useStyles from './useStyles';

const LoanOfficerProfileReviewPopup = props => {
  const { onClose, onNext, loanOfficer } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { isMobile, isDesktop } = useScreen();

  const videoUrl = LoanOfficerPresenter.profileVideoUrl(loanOfficer);
  const isProfileVideoPresent = isPresent(videoUrl);

  const handleNext = () => onNext(loanOfficer);

  return (
    <Dialog open onClose={onClose} fullScreen={isMobile}>
      <div className={clsx(classes.container, { [classes.blackBackground]: isProfileVideoPresent })}>
        <div className={classes.header}>
          {isProfileVideoPresent && isDesktop && (
            <Typography variant="h1">
              {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficerProfileReviewPopup.videoHeader')}
            </Typography>
          )}
          {isProfileVideoPresent && isMobile && <Icon name="grayLogo" width="100" />}
          {!isProfileVideoPresent && (
            <Typography variant="h2">
              {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficerProfileReviewPopup.infoHeader')}
            </Typography>
          )}
          <IconButton onClick={onClose}>
            <Icon name="bigClose" />
          </IconButton>
        </div>
        {isProfileVideoPresent ? (
          <div className={classes.videoContainer}>
            <VideoPlayer url={videoUrl} width="500" autoplay />
          </div>
        ) : (
          <div className={classes.profileReviewContainer}>
            <LoanOfficerInfoBar loanOfficer={loanOfficer} />
          </div>
        )}
        <div className={classes.buttonContainer}>
          <Button onClick={handleNext} className={classes.button}>
            {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficerProfileReviewPopup.button')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

LoanOfficerProfileReviewPopup.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default LoanOfficerProfileReviewPopup;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LoanOfficerSelect/components/LoanOfficerProfileReviewPopup/LoanOfficerProfileReviewPopup.js